import { useState, useEffect, useCallback } from "react";

import Table from "../../../components/common/Table";
import Pagination from "./../../../components/common/Pagination";
import Toaster from "../../../components/common/Toaster";

import complianceService from "../../../services/complianceService";
import moment from "moment";

const S2LicenseTable = (props) => {
  const { id, data, columns, tableOptions, setData, onChange } = props;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const response = await complianceService.getAccountS2LicensesAsync(
          id,
          tableOptions
        );

        const { result, page, total_count } = response;

        const items = result.map((item) => {
          const { registration_date, validity } = item;

          item["registration_date"] = moment(registration_date).format("LL");
          item["validity"] = moment(validity).format("LL");

          return item;
        });

        if (mounted) {
          setData(items);
          setCurrentPage(page);
          setTotalCount(total_count);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [id, tableOptions, setData]
  );

  const handleSort = (sort_column) => {
    const options = { ...tableOptions };
    options.sort_column = sort_column;
    onChange(options);
  };

  const handlePageChange = (page) => {
    const options = { ...tableOptions };
    options.current_page = page;
    onChange(options);
  };

  useEffect(() => {
    let mounted = true;

    fetchData(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchData]);

  return (
    <div className="mt-10 overflow-auto lg:overflow-visible">
      <Table
        data={data}
        columns={columns}
        sortColumn={tableOptions.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={tableOptions.page_size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default S2LicenseTable;
